import { render, staticRenderFns } from "./ClaimWalletListActions.vue?vue&type=template&id=1f1611c7&"
import script from "./ClaimWalletListActions.vue?vue&type=script&lang=js&"
export * from "./ClaimWalletListActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports